export default __webpack_public_path__ + "34d8401f8981c4bbeec26de3f86d9081.svg";